export default () => {
    document.querySelectorAll('label img').forEach((labelImg: HTMLElement) => {
        labelImg.addEventListener('click', () => {
            const label: HTMLElement | null = labelImg.parentElement;
            if (label) {
                const targetId = label.getAttribute("for");
                document.getElementById(targetId).click();
            }
        });
    });
}